<template lang="pug">
.send-request-reply-facility
  .facility-category {{ _facilityCategory }}
  .facility-name {{ _facilityName }}
  .facility-address {{ _facilityAddress }}
  a.link.facility-url(:href="_facilityUrl" target="_blank")
    span.link-text(style="margin:0;") {{ _facilityUrl }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { FacilityCategory, FacilityGetModel } from "@/commons/services/Facilities";

/**
 * ### 返信状況タブの施設情報コンポーネント
 */
@Component
export default class SendRequestReplyFacility extends Vue {
  /** 親コンポーネントでv-modelで指定した値 */
  @Prop()
  value!: FacilityGetModel;

  get _value(): FacilityGetModel {
    return this.value;
  }

  get _facilityCategory(): string {
    if (!this.value.facilityCategory) {
      return "";
    }

    switch (this.value.facilityCategory) {
      /** 介護付有料老人ホーム */
      case FacilityCategory.KAIGO_YUURYOU: {
        return "介護付有料老人ホーム";
      }
      /** 住宅型有料老人ホーム */
      case FacilityCategory.JYUUTAKU_YUURYOU: {
        return "住宅型有料老人ホーム";
      }
      /** サービス付き高齢者向け住宅 */
      case FacilityCategory.SERVICE_JYUUTAKU: {
        return "サービス付き高齢者向け住宅";
      }
      /** シニア向け分譲マンション */
      case FacilityCategory.CONDOMINIUMS: {
        return "シニア向け分譲マンション";
      }
      /** グループホーム */
      case FacilityCategory.GROUP_HOME: {
        return "グループホーム";
      }
      /** ケアハウス */
      case FacilityCategory.CARE_HOUSE: {
        return "ケアハウス";
      }
      /** 特別養護老人ホーム（特養）*/
      case FacilityCategory.TOKUYO: {
        return "特別養護老人ホーム（特養）";
      }
      /** 介護老人保健施設（老健） */
      case FacilityCategory.KAIGO_HOKEN: {
        return "介護老人保健施設（老健）";
      }
      /** 介護医療院 */
      case FacilityCategory.MEDICAL_CENTER: {
        return "介護医療院";
      }
      /** その他 */
      case FacilityCategory.OTHER: {
        return "その他";
      }
      /** デフォルト */
      default: {
        return "";
      }
    }
  }

  get _facilityName(): string {
    return this.value.name ? this.value.name : "";
  }

  get _facilityAddress(): string {
    if (!this.value.addressInfo) {
      return "";
    }
    return `${this.value.addressInfo.prefecture} ${this.value.addressInfo.municipality}`;
  }

  get _facilityUrl(): string {
    return this.value.url ? this.value.url : "";
  }
}
</script>

<style lang="scss" scoped>
.send-request-reply-facility {
  .facility-category {
    font-size: 14px;
  }
  .facility-name {
    font-size: 16px;
    font-weight: bold;
  }
  .facility-address {
    font-size: 14px;
  }
  .facility-url {
    font-size: 14px;
  }
}
</style>
